import React from "react";
import { Route, Routes } from "react-router-dom";

import ServiceInterfaceLogsPage from "@/components/screens/ServiceInterfaceLogs";
import ServiceInterfacesPage from "@/components/screens/ServiceInterfaces";
import { SERVICE_INTERFACE_MESSAGES } from "@/messages/service-interface/service-interface.messages";

const IntegrationsPage: React.FC = () => {
  return (
    <Routes>
      <Route path="/:lang" element={<ServiceInterfacesPage messages={SERVICE_INTERFACE_MESSAGES} />} />
      <Route
        path="/:serviceInterfaceId/logs/:lang"
        element={<ServiceInterfaceLogsPage messages={SERVICE_INTERFACE_MESSAGES} />}
      />
      <Route path="/" element={<ServiceInterfacesPage messages={SERVICE_INTERFACE_MESSAGES} />} />
    </Routes>
  );
};

export default IntegrationsPage;
